import React, { ReactElement, useEffect } from 'react'
import styled from 'styled-components'

import {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../../../1stlog-ui/src/components/Field/useFieldState'

const Wrapper = styled.div``

const HazmatPoints = (): ReactElement => {
  const count = useField('count')
  const amount = useField('amount')
  const allowedFor1000PointTransport = useField('allowedFor1000PointTransport')
  const pointMultiplicator = useField('pointMultiplicator')
  const limitedQuantityEnabled = useField('limitedQuantityEnabled')
  const [calculatedPoints, setCalculatedPoints] =
    useFieldState('calculatedPoints')

  useEffect(() => {
    if (
      !allowedFor1000PointTransport ||
      pointMultiplicator === 0 ||
      limitedQuantityEnabled
    ) {
      setCalculatedPoints(0)
      return
    }

    const p = pointMultiplicator * amount * count

    setCalculatedPoints(Math.round(Number(p)))
  }, [count, amount, pointMultiplicator])

  if (
    !allowedFor1000PointTransport ||
    pointMultiplicator === 0 ||
    limitedQuantityEnabled
  ) {
    return <></>
  }

  return (
    <Wrapper>
      <Label>{i18n.t('hazmat_points', 'Gefahrgutpunkte')}</Label>
      <div className="mt-1">
        <strong>{Math.round(Number(calculatedPoints))}</strong> Punkte
      </div>
    </Wrapper>
  )
}

export default HazmatPoints
